"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@vercel/analytics";
import type { ComponentProps } from "react";
import { CURRENT_EVENT_YEAR } from "@/features/event/event-config";
import { useAnalyticsEventYear } from "./event-analytics-provider";
export type OrganicConversionEvent = "hotel_booking_click" | "registration_click" | "schedule_open";
type TrackedExternalLinkProps = ComponentProps<"a"> & {
  eventName: OrganicConversionEvent;
  eventYear?: number;
  href: string;
  placement: string;
};
export function TrackedExternalLink(t0) {
  const $ = _c(16);
  let eventName;
  let eventYear;
  let href;
  let onClick;
  let placement;
  let props;
  if ($[0] !== t0) {
    ({
      eventName,
      eventYear,
      href,
      onClick,
      placement,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = eventName;
    $[2] = eventYear;
    $[3] = href;
    $[4] = onClick;
    $[5] = placement;
    $[6] = props;
  } else {
    eventName = $[1];
    eventYear = $[2];
    href = $[3];
    onClick = $[4];
    placement = $[5];
    props = $[6];
  }
  const currentEventYear = useAnalyticsEventYear();
  const resolvedEventYear = eventYear ?? currentEventYear ?? CURRENT_EVENT_YEAR;
  let t1;
  if ($[7] !== eventName || $[8] !== onClick || $[9] !== placement || $[10] !== resolvedEventYear) {
    t1 = event => {
      track(eventName, {
        placement,
        event_year: String(resolvedEventYear)
      });
      onClick?.(event);
    };
    $[7] = eventName;
    $[8] = onClick;
    $[9] = placement;
    $[10] = resolvedEventYear;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== href || $[13] !== props || $[14] !== t1) {
    t2 = <a {...props} href={href} onClick={t1} />;
    $[12] = href;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}